























































































import { ObjectType } from 'expangine-runtime';
import { ListOptions } from '../../../common';
import { ObjectFormOptions } from './ObjectFormTypes';
import TypeSettingsBase from '../TypeSettingsBase';


interface SizeOption { columns: string; offset: string; }

const sizeOptions: ListOptions<SizeOption> = [
  { text: 'Small to large handset (<600px)', value: { columns: 'cols', offset: 'offset' } },
  { text: 'Small to medium tablet (<960px)', value: { columns: 'sm', offset: 'offsetSm' } },
  { text: 'Large tablet to laptop (<1264px)', value: { columns: 'md', offset: 'offsetMd' } },
  { text: 'Desktop (<1904px)', value: { columns: 'lg', offset: 'offsetLg' } },
  { text: '4k and ultra-wides (>1904px)', value: { columns: 'xl', offset: 'offsetXl' } },
];

const columnOptions: ListOptions<number | undefined> = [
  { text: 'auto', value: undefined },
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5', value: 5 },
  { text: '6', value: 6 },
  { text: '7', value: 7 },
  { text: '8', value: 8 },
  { text: '9', value: 9},
  { text: '10', value: 10 },
  { text: '11', value: 11 },
  { text: '12', value: 12 },
];

const offsetOptions: ListOptions<number | undefined> = [
  { text: '0', value: undefined },
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
  { text: '4', value: 4 },
  { text: '5', value: 5 },
  { text: '6', value: 6 },
  { text: '7', value: 7 },
  { text: '8', value: 8 },
  { text: '9', value: 9},
  { text: '10', value: 10 },
  { text: '11', value: 11 },
];

export default TypeSettingsBase<ObjectType, ObjectFormOptions>().extend({
  name: 'ObjectFormSettings',
  data: () => ({
    outside: null as null | string,
    size: sizeOptions[0].value,
  }),
  computed: {
    sizeOptions: () => sizeOptions,
    columnOptions: () => columnOptions,
    offsetOptions: () => offsetOptions,
    hasOutside(): boolean {
      return this.outsideOptions.length > 0;
    },
    outsideOptions(): ListOptions<string> {
      const columns = this.value.columns;
      const props = Object.assign({}, this.type.options.props);
      
      for (const col of columns) {
        delete props[col.prop];
      }

      const outside = Object.keys(props);

      return outside.map((prop) => ({
        text: prop,
        value: prop,
      }));
    },
  },
  methods: {
    add() {
      const prop = this.outside || this.outsideOptions[0].value;

      this.value.columns.push({ prop, cols: 12 });
      this.input();
    },
    move(index: number, dir: number) {
      const columns = this.value.columns;
      const next = index + dir;
      if (next < 0 || next >= columns.length) {
        return;
      }
      const temp = columns[index];
      this.$set(columns, index, columns[next]);
      this.$set(columns, next, temp);
      this.input();
    },
  },
});
